import React from 'react';

import * as Dialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import './rstyles.css';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';

import { ulid } from 'ulid';

// import DateTimePicker from 'react-datetime-picker';

function ReminderDialog() {
  const now = new Date();
  const initYear = now.getFullYear();
  const initMonth = String(now.getMonth() + 1).padStart(2, '0');
  const initDay = String(now.getDate()).padStart(2, '0');
  const initHour = String(now.getHours()).padStart(2, '0');
  const initMinute = String(now.getMinutes()).padStart(2, '0');
  const initDateTime = `${initYear}-${initMonth}-${initDay}T${initHour}:${initMinute}`;

  const {
    createReminder,
    reminderDialogOpen,
    reminderBeingEdited,
    setReminderBeingEdited,
    setReminderDialogOpen,
    updateReminder,
    editAll,
    setEditAll,
    deleteReminder,
  } = React.useContext(DataContext);
  const initReminderValue = reminderBeingEdited
    ? reminderBeingEdited.reminder
    : '';
  const initDateValue = reminderBeingEdited
    ? convertToDateTimeLocal(reminderBeingEdited.datetime)
    : initDateTime;
  const [reminderText, setReminderText] = React.useState(initReminderValue);
  const [dateTime, setDateTime] = React.useState(initDateValue);
  const [untilDateTime, setUntilDateTime] = React.useState(initDateValue);
  const [reminderRepeatIntervalUnit, setReminderRepeatIntervalUnit] =
    React.useState('never');

  const reminderIsLongEnough = reminderText.length >= 1;
  const reminderIsShortEnough = reminderText.length <= 90;

  const formatDateTime = (dateTime) => {
    const [datePart, timePart] = dateTime.split('T');
    const [year, month, day] = datePart.split('-');
    let [hour, minute] = timePart.split(':');
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    hour = h < 10 ? `0${h}` : `${h}`;
    return `${month}-${day}-${year}-${hour}:${minute}${ampm}`;
  };

  const handleReminderCreateOrUpdate = () => {
    const unixTime = Math.floor(new Date(dateTime).getTime() / 1000);
    const formatted = formatDateTime(dateTime);
    const newUlid = ulid(unixTime * 1000);

    if (!reminderIsLongEnough) {
      window.alert(
        'Reminder is not valid! It must be at least 1 character long.'
      );
      return;
    }

    if (!reminderIsShortEnough) {
      window.alert(
        'Reminder is not valid! It must be less than 90 characters long.'
      );
      return;
    }

    const body = {
      reminder: reminderText,
      id: newUlid,
      datetime: formatted,
      KEY: newUlid,
      PK1: 'REMINDER',
      SK1: newUlid,
      edit_all: editAll,
    };

    if (reminderBeingEdited) {
      body['prev_id'] = reminderBeingEdited.KEY;
      body['prev_reminder'] = reminderBeingEdited.reminder;
      handleReminderUpdate(body);
    } else {
      if (reminderRepeatIntervalUnit !== 'never') {
        body['repeat_interval_unit'] = reminderRepeatIntervalUnit;
        body['until_datetime'] = formatDateTime(untilDateTime);
      }
      handleReminderCreate(body);
    }
  };

  const handleReminderUpdate = (body) => {
    console.log(`reminderText=${reminderText}`);
    console.log(`dateTime=${dateTime}`);
    console.log(`hru body=${JSON.stringify(body)}`);
    updateReminder(body);
    setReminderDialogOpen(false);
  };

  const handleReminderCreate = (body) => {
    console.log(`body=${JSON.stringify(body)}`);
    createReminder(body);
    setReminderDialogOpen(false);
  };

  // ... existing code ...
  <input
    aria-label='Date and time'
    type='datetime-local'
    value={dateTime}
    onChange={(e) => setDateTime(e.target.value)}
  />;
  // ... existing code ...
  const submitButtonText = reminderBeingEdited ? 'Update' : 'Add';

  return (
    <Dialog.Root
      open={reminderDialogOpen}
      onOpenChange={() => {
        setReminderDialogOpen((oldValue) => {
          return !oldValue;
        });
        setReminderBeingEdited(null);
        setEditAll(false);
      }}
    >
      <Dialog.Trigger asChild>
        <button class='btn-fab' aria-label='Create new reminder'>
          ＋
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className='ReminderDialogOverlay' />
        <Dialog.Content className='ReminderDialogContent'>
          <p className='ReminderDialogText'>Add your reminder</p>
          <fieldset className='ReminderDialogFieldset'>
            <label className='ReminderDialogLabel' htmlFor='email'>
              Reminder
            </label>
            <input
              value={reminderText}
              onChange={(e) => setReminderText(e.target.value)}
              className='ReminderDialogInput'
              id='remindertext'
              type='text'
            />
          </fieldset>
          <fieldset className='ReminderDateFieldset'>
            <label className='ReminderDateLabel' htmlFor='dueDate'>
              Due:{' '}
            </label>
            <input
              aria-label='Date and time'
              type='datetime-local'
              value={dateTime}
              onChange={(e) => setDateTime(e.target.value)}
            />
          </fieldset>
          {!reminderBeingEdited && (
            <fieldset className='ReminderDialogFieldset'>
              <label className='ReminderDialogLabel' htmlFor='repeatFrequency'>
                Repeat Frequency
              </label>
              <select
                id='repeatFrequency'
                value={reminderRepeatIntervalUnit}
                onChange={(e) => setReminderRepeatIntervalUnit(e.target.value)}
              >
                <option value='never'>Never</option>
                <option value='daily'>Daily</option>
                <option value='weekly'>Weekly</option>
                <option value='biweekly'>Biweekly</option>
                <option value='monthly'>Monthly</option>
                <option value='quarterly'>Quarterly</option>
                <option value='biannually'>Biannually</option>
                <option value='yearly'>Yearly</option>
              </select>
            </fieldset>
          )}
          {reminderRepeatIntervalUnit !== 'never' && (
            <fieldset className='ReminderDateFieldset'>
              <label className='ReminderDateLabel' htmlFor='untilDueDate'>
                Until:{' '}
              </label>
              <input
                aria-label='Until date and time'
                type='datetime-local'
                value={untilDateTime}
                onChange={(e) => setUntilDateTime(e.target.value)}
              />
            </fieldset>
          )}

          {reminderBeingEdited && (
            <fieldset className='ReminderCheckboxFieldset'>
              <label
                className='ReminderCheckboxLabel'
                htmlFor='editAll'
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px',
                  marginBottom: 0,
                }}
              >
                Edit All
              </label>
              <input
                id='editAll'
                type='checkbox'
                checked={editAll}
                onChange={(e) => setEditAll(e.target.checked)}
              />
            </fieldset>
          )}

          {reminderIsLongEnough ? (
            <div style={{ color: 'green' }}>&gt;=1 character</div>
          ) : (
            <div style={{ color: 'red' }}>&lt;1 character</div>
          )}
          {reminderIsShortEnough ? (
            <div style={{ color: 'green' }}>&lt;=90 character</div>
          ) : (
            <div style={{ color: 'red' }}>&gt;90 character</div>
          )}
          {reminderBeingEdited && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  if (
                    window.confirm(
                      'Are you sure you want to delete all reminders?'
                    )
                  ) {
                    deleteReminder(reminderBeingEdited.KEY, true);
                  }
                }}
                className='ReminderDialogButton red'
              >
                DELETE ALL
              </button>
            </div>
          )}
          <div
            style={{
              display: 'flex',
              marginTop: 20,
              justifyContent: 'flex-end',
            }}
          >
            <button
              onClick={handleReminderCreateOrUpdate}
              className='ReminderDialogButton green'
            >
              {submitButtonText}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

function convertToDateTimeLocal(str) {
  // Example input: "06-05-2025-08:00PM"
  // Desired output: "2025-06-05T20:00"

  // Step 1: split by '-' first
  const [month, day, year, timePortion] = str.split('-');
  // timePortion might look like "08:00PM", so let's separate the numeric part from AM/PM
  const match = timePortion.match(/^(\d{1,2}:\d{2})(AM|PM)$/);
  if (!match) return ''; // or handle error
  const [, hourMin, ampm] = match; // e.g. hourMin="08:00", ampm="PM"
  let [hour, minute] = hourMin.split(':');
  let h = parseInt(hour, 10);

  // Step 2: do 12-hour to 24-hour conversion
  if (ampm === 'PM' && h < 12) {
    h += 12;
  } else if (ampm === 'AM' && h === 12) {
    h = 0;
  }
  hour = String(h).padStart(2, '0');

  // Step 3: format final
  // "YYYY-MM-DDThh:mm"
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hour}:${minute}`;
}

export default ReminderDialog;

const AddReminderSpan = styled.span`
  margin-left: 10px;
`;

const plusIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-circle-plus'
  >
    <circle cx='12' cy='12' r='10' />
    <path d='M8 12h8' />
    <path d='M12 8v8' />
  </svg>
);
